module.exports = __webpack_public_path__ + "3bb7e7211005b32677da4a28fd335c33.MP3";